export enum InvoiceBatchColumnSort {
  createdAt = 'createdAt',
  id = 'id'
}
